import { Component, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material';
import { ApiService } from 'src/app/core/services/api.service';
import { MessageService } from 'src/app/core/services/message.service';
import { ConfirmDialogComponent } from 'src/app/shared/confirm-dialog/confirm-dialog.component';
import { DataTableComponent } from 'src/app/shared/data-table/data-table.component';
import { ShipDto } from 'src/app/dtos/ship-dto';

@Component({
    selector: 'ships',
    templateUrl: './ships.component.html',
    styleUrls: ['./ships.component.scss']
})

export class ShipsComponent {

  search: any;
  @ViewChild("tableChild") tableChild: DataTableComponent<ShipDto>;
  pagePath: string = "api/ship/page";
  searchText: string = '';
  options = {
  columnTitles: ["SHIPC.TABLE.GUIDENUMBER", "SHIPC.TABLE.REGISTERDATE" , "SHIPC.TABLE.CLIENT", "GENERAL.LABELS.ACTIONS"],
  columnReferences: ["guideNumber", 'registerDate', 'shipmentClient', 'actions'],
  actionButtons: { edit: true, delete: false }
  };
    
    constructor(private router: Router, public dialog: MatDialog, private apiService: ApiService, private messageService: MessageService) {

    }

    goToEdit(e: any) {
      this.router.navigate(["ships/edit", e.id]);
    }

    openDeleteDialog(e: any) {
        const dialogRef = this.dialog.open(ConfirmDialogComponent, {
          width: '680px',
          data: {
            title: 'DIALOGS.DELETE_SHIP.TITLE',
            body: 'DIALOGS.DELETE_SHIP.BODY',
            cancelButtonText: "GENERAL.LABELS.CANCEL",
            confirmButtonText: "GENERAL.LABELS.DELETE",
          }
        });
    
        dialogRef.afterClosed().subscribe(result => {
          if (result) {
            this.apiService.delete('api/ship/' + e.id).subscribe(data => {
              this.messageService.success("Exito", "El envio fue removido exitosamente");
              this.tableChild.loadPage();
            }, error => {
              this.messageService.error("Error", error.message);
            })
          }
        });
      }

      searchShip(){
        this.search = {
            searchText: this.searchText
          }
          this.tableChild.firstPage();
          this.tableChild.loadPage(this.search);
    }
}
